import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const validateAccess = async (e) => {
  const baseUrl = window.config.ePersonamService.ePersonamHost + '/' + window.locale;
  const url = `${baseUrl}/smartlea/get_smartlea_access_verification.json`;

  Loader.show();

  try {
    let accessId = e.target.dataset.accessId;
    let params = { access_id: accessId };
    const { data } = await apiConnector().post(url, params);
    const icon = document.getElementById(`access_warning_${accessId}`);

    icon.className = data.class;
    icon.title = data.title;

    if (data.remove_button) {
      e.target.remove();
    }
  } catch (e) {
    console.error('qualcosa non ha funzionato nel recupero delle validazione', e);
  } finally {
    Loader.hide();
  }
};

const addAccessListeners = async () => {
  const accesses = document.querySelectorAll('.verify_smartlea_access');

  accesses.forEach((access) => {
    access.addEventListener('click', (e) => {
      validateAccess(e);
    });
  });
};
const init = () => {
  try {
    addAccessListeners();
    eventBus.$on('smartleaValidationInit', () => addAccessListeners());
  } catch (e) {
    errorManager(e);
  }
};

window.SmartleaValidation = {
  init: init,
};
